import React, { useEffect, useState } from 'react'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useNavigate } from 'react-router-dom';

const waitingTime = 5;
let timerSeconds = waitingTime;
const Autoplay = ({ episodes, setIsAutoplayView, isPlaylist = false, onVideoChange, currentVideoId, season, template, thumbnailOrientation }) => {
    const [timer, setTimer] = useState(waitingTime)
    const navigate = useNavigate()

    useEffect(() => {
        if (isPlaylist && episodes) {
            playNextEpisodeHandler();
            return;
        }
        const interval = setInterval(() => {
            timerSeconds--
            if (timerSeconds >= 0) {
                setTimer((prev) => prev - 1)
            } else {
                clearInterval(interval)
            }

        }, 1000);

        return () => {
            clearInterval(interval)
            resetValues()
        }
    }, [])

    useEffect(() => {
        if (timer === 0) {
            playNextEpisodeHandler()
        }
    }, [timer])

    const playNextEpisodeHandler = () => {
        setIsAutoplayView(false)
        setTimer(waitingTime)
        timerSeconds = waitingTime
        if (isPlaylist && episodes) {
            const currentIndex = episodes.findIndex(
                (episode) => episode.video_id === currentVideoId
            );

            const nextIndex = currentIndex + 1;
            onVideoChange(episodes[nextIndex]);
        } else {
            navigate(`/videos/${episodes[0]?.vanity_url}`, { state: { videoDetails: { video_id: episodes[0]?.video_id } } })
        }
    }

    const resetValues = () => {
        setTimer(waitingTime)
        timerSeconds = waitingTime

    }

    return (
        <div className='autoplayComponent'>
            <div className="content" style={{
                backgroundImage: episodes && episodes[0]?.thumbnail_350_200
                    ? `url(${episodes[0].thumbnail_350_200})`
                    : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: '300px',
                cursor: 'pointer'
            }} onClick={() => { playNextEpisodeHandler() }}>

                <div className="progressBar">
                    <CircularProgressbar
                        value={Math.round((waitingTime - timer) * waitingTime)}
                        text={`${timer}s`}
                        styles={buildStyles({
                            pathColor: `var(--button-color)`,
                            textColor: `var(--button-color)`,
                        })}
                    />
                </div>
                <div><h1 className="heading" style={{ marginTop: '10px', color: '#fff', background: 'rgb(8 7 7 / 26%)', padding: '5px 10px', borderRadius: '4px' }}>{episodes[0]?.video_title}</h1></div>

            </div>
        </div>
    )
}

export default Autoplay
